import { Link as RouterLink } from 'react-router-dom';
import { Body, Heading } from '@internal/kern-ux';

/**
 * KERN 404 page: states clearly what happened and offers a way back.
 */
export const KernNotFoundPage = () => (
  <div className="vf-page">
    <Heading type="x-large" headerElement="h1" title="Seite nicht gefunden" />
    <Body text="Die aufgerufene Adresse existiert nicht oder wurde verschoben." />
    <RouterLink className="kern-link" to="/">
      Zur Startseite
    </RouterLink>
  </div>
);
